
// Las URLs se resuelven según el modo de Vite:
//   yarn dev:staging →  .env.staging   (localhost)
//   yarn dev         →  .env.development  (QA)
//   yarn dev:prod    →  .env.production   (Producción)
//   yarn build:dev   →  .env.development  (QA)
//   yarn build       →  .env.production   (Producción)

export const BaseUrlAfilRenanWs    = import.meta.env.VITE_API_URL_AFILRENANWS;
export const BaseUrlNewPrest       = import.meta.env.VITE_API_URL_AFILRENANWS_API;
export const BaseUrlNew            = import.meta.env.VITE_API_URL_AFILRENANWS_API2;

export const BaseUrlAfil           = import.meta.env.VITE_API_URL_APIRENACER;
export const BaseUrlPrest          = import.meta.env.VITE_API_URL_APIRENACER;
export const BaseUrlApiRenacer     = import.meta.env.VITE_API_URL_APIRENACER;

export const BaseUrlValidAfiliado  = import.meta.env.VITE_API_URL_AFILIADOS;
export const BaseUrlValidPrestador = import.meta.env.VITE_API_URL_PRESTADORES;
export const BaseUrlValidPromotor  = import.meta.env.VITE_API_URL_PROMOTORES;

export const BaseUrlUserRol        = import.meta.env.VITE_API_URL_ROLES;
export const BaseUrlUser           = import.meta.env.VITE_API_URL_USUARIO;
export const BaseUrlUsers          = import.meta.env.VITE_API_URL_USUARIOS;

export const RestablecerPass       = import.meta.env.VITE_API_URL_RESTABLECER_PASS;

export const BaseUrlApiCarnetPrint = import.meta.env.VITE_API_URL_APICARNETPRINT;
export const BaseUrlInfo           = import.meta.env.VITE_API_URL_INFO;
